import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizeInterceptor implements HttpInterceptor {
  constructor(
    private authorize: AuthService,
    private router: Router
    ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authorize.getToken()
      .pipe(mergeMap(token => this.processRequestWithToken(token, req, next)));
  }

  // Checks if there is an access_token available in the authorize service
  // and adds it to the request in case it's targeted at the same origin as the
  // single page application.
  private processRequestWithToken(token: string, req: HttpRequest<any>, next: HttpHandler) {
    //console.log('processRequestWithToken', req);
    if (!!token) { //} && this.isSameOriginUrl(req)) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req);

    // if (!!token) { // && this.isSameOriginUrl(req)) {

    //   const headers = new HttpHeaders({
    //     'Authorization': `Bearer ${token}`,
    //     'Content-Type': 'application/json'
    //   })

    //   const authReq = req.clone({ headers });

    //   //return next.handle(authReq);
    //   return next.handle(authReq).pipe(tap(() => { },
    //   (err: any) => {
    //     //console.log('there was an error', err);
    //     if (err instanceof HttpErrorResponse) {
    //       if (err.status !== 401) {
    //         return;
    //       }
    //       //console.log('it was a 401');
    //       // const check = this.authorize.checkSignedIn().then(value => {
    //       //   return;
    //       // });
    //       // this.router.navigate(['/authentication/login']);
    //       this.router.navigate(['/authentication/login'], {queryParams: { 'returnUrl': this.authorize.attemptedUrl }} );
    //     }
    //   }));
    //   //req = req.clone({
    //   //  setHeaders: {
    //   //  Authorization: `Bearer ${token}`
    //   //  }
    //   //});

    // } else {
    //   console.log("AuthorizeInterceptor not logged in");
    // }

    // //return next.handle(req);
    // return next.handle(req).pipe(tap(() => { },
    //   (err: any) => {
    //     //console.log('there was an error', err);
    //     if (err instanceof HttpErrorResponse) {
    //       if (err.status !== 401) {
    //         return;
    //       }
    //       //console.log('it was a 401');
    //       //this.router.navigate(['/authentication/login']);
    //       this.router.navigate(['/authentication/login'], {queryParams: { 'returnUrl': this.authorize.attemptedUrl }} );
    //     }
    //   }));

  }

  private isSameOriginUrl(req: any) {
    // It's an absolute url with the same origin.
    if (req.url.startsWith(`${window.location.origin}/`)) {
      return true;
    }

    // It's a protocol relative url with the same origin.
    // For example: //www.example.com/api/Products
    if (req.url.startsWith(`//${window.location.host}/`)) {
      return true;
    }

    // It's a relative url like /api/Products
    if (/^\/[^\/].*/.test(req.url)) {
      return true;
    }

    // It's an absolute or protocol relative url that
    // doesn't have the same origin.
    return false;
  }
}
